<template>
    <div class="com-item about-module" :key="index">
        <div class="component person-nav">
            <div
                class="van-sticky aboutView"
                :style="{
                    backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                    backgroundColor: modata.WContent.bgColor || 'transparent',
                    color: modata.WContent.textColor || '#262626'
                }"
            >
                <div class="aboutView__container">
                    <div class="aboutView__head">
                        <p class="aboutView__en">{{ modata.WContent.enTitle }}</p>
                        <p class="aboutView__cn">{{ modata.WContent.cnTitle }}</p>
                        <div class="aboutView__desc" v-html="modata.WContent.describe"></div>
                    </div>
                    <div
                        class="aboutView__metrics"
                        v-if="modata.WContent.metrics && modata.WContent.metrics.length"
                    >
                        <div
                            class="aboutView__metric"
                            v-for="(item, i) in modata.WContent.metrics"
                            :key="i"
                            @click="bindPage(item)"
                        >
                            <div class="aboutView__metric-num">
                                <span class="value">{{ item.value }}</span>
                                <span class="unit">{{ item.unit }}</span>
                            </div>
                            <p class="aboutView__metric-label">{{ item.label }}</p>
                        </div>
                    </div>
                    <a
                        v-if="modata.WContent.btnText"
                        class="aboutView__btn"
                        :href="modata.WContent.btnLink && modata.WContent.btnLink.linkUrl ? modata.WContent.btnLink.linkUrl : 'javascript:void(0)'"
                        target="_self"
                        @click.stop="onBtnClick($event)"
                    >
                        <span>{{ modata.WContent.btnText }}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "about-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'about',
                    Title: '关于我们',
                    MID: 10,
                    WID: null,
                    ModuleName: 'about-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        bindPage(item) {
            if (!item || !item.linkUrl) return
            this.pageNavigate(item.linkUrl)
        },
        onBtnClick(e) {
            const W = this.modata.WContent || {}
            if (!W.btnLink || !W.btnLink.linkUrl) {
                e.preventDefault()
                return
            }
            e.preventDefault()
            this.pageNavigate(W.btnLink.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
p {
    margin: 0;
}
.about-module {
    .aboutView {
        min-height: 300px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center right;
        padding-top: 10%;
        padding-bottom: 10%;
    }

    .aboutView__container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        width: 90%;
        max-width: 1600px;
        margin-left: auto;
        margin-right: auto;
    }

    .aboutView__en {
        line-height: normal;
        font-size: 18px;
        color: #004ea2;
    }

    .aboutView__cn {
        line-height: normal;
        font-size: 42px;
        font-weight: bold;
        margin-top: 10px;
    }

    .aboutView__desc {
        margin-top: 20px;
        min-height: 50px;
        font-size: 18px;
        line-height: 1.7;
        max-width: 950px;
        color: #737373;

        ::v-deep p { margin: 0 0 8px; }
    }

    .aboutView__metrics {
        display: flex;
        flex-wrap: wrap;
        margin-top: 3%;
        max-width: 800px;
    }

    .aboutView__metric {
        flex: 0 0 33.3%;
        position: relative;
        cursor: pointer;
    }

    .aboutView__metric-num {
        display: flex;
        align-items: baseline;
        color: #004ea2;
        margin-bottom: 10px;

        .value {
           font-size: 3.2vw;
            font-weight: normal;
            line-height: 1;
            font-family: "pingfang heavy";
        }
        .unit {
            font-size: 20px;
            padding-left: 5px;
            line-height: 1;
        }
    }

    .aboutView__metric-label {
        line-height: normal;
        text-align: left;
        margin-top: 0;
        font-size: 18px;
        padding-left: 20px;
    }

    .aboutView__btn {
        display: inline-block;
        position: relative;
        overflow: hidden;
        text-align: center;
        box-sizing: border-box;
        width: 160px;
        margin-top: 5%;
        padding: 13px 0;
        background-color: #004ea2;
        border: none;
        border-radius: 40px;
        color: #fff;
        font-size: 15px;
        text-decoration: none;
        transition: all 0.3s;

        span {
            display: block;
            width: 100%;
            position: relative;
            z-index: 1;
        }

        &:hover {
            background-color: #004ea2;
        }
    }
}

@media screen and (max-width: 768px) {
    .about-module {
        .aboutView {
            background-size: contain;
            background-color: #ddeafa;
            background-position: bottom;
        }
        .aboutView__en{
            font-size: 24px;
        }
        .aboutView__cn {
            font-size: 34px;
            font-weight: 400;
            line-height: 1;
            margin-top: 5px;
        }
        .aboutView__desc {
          
           font-size: 20px;
           margin-top: 30px;
        }

        .aboutView__metric-num .value{
            font-size: 37px;
        }
        .aboutView__metric-num .unit{
            font-size: 22px;
        }
        .aboutView__metric-label{
            padding-left: 0;
        }
        .aboutView__btn{
            margin: 40px 0 50px;
        }

    }
}
</style>
